import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-purchase-progress',
  templateUrl: './purchase-progress.page.html',
  styleUrls: ['./purchase-progress.page.scss'],
})
export class PurchaseProgressPage implements OnInit, OnDestroy {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() { }

  public onClose = (accept: boolean) => this.modalCtrl.dismiss(accept);

}
